<div class="userProfile">
	<div class="label">
		<app-online-indicator [color]="connected ? 'green' : 'red'" [size]="10" style="margin-right: 4px;"></app-online-indicator>
		&nbsp;&nbsp;{{spotName}}
		<ng-container *ngIf="callsActions">
			<div class="videoIcon">
				<div class="turnOfLine" *ngIf="!callsActions.video"></div>
				<fa-icon [icon]="['fas','video']"></fa-icon>
			</div>
			<div class="videoIcon" [class.on]="callsActions.hand">
				<fa-icon [icon]="['fas','hand-paper']"></fa-icon>
			</div>
			<div ngbDropdown container="body" class="d-inline-block" style="float: right; text-align: right; width: 10px; cursor: pointer;margin-right: 7px;">
				<div ngbDropdownToggle id="settings" *ngIf="isOwner">
					<fa-icon [icon]="['fas','cog']"></fa-icon>
				</div>
				<div ngbDropdownMenu aria-labelledby="settings">
					<button ngbDropdownItem *ngIf="!micStarted" (click)="startMic()">Unmute</button>
					<button ngbDropdownItem *ngIf="micStarted" (click)="closeMic()">Mute</button>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="videoContainer" [id]="streamId">
	</div>
</div>